class MetaData {
  constructor(ppi = null, maxZoomLevelPercentage = null, author = null, title = null, uuid = null) {
    this.ppi = ppi
    this.maxZoomLevelPercentage = maxZoomLevelPercentage
    this.author = author
    this.title = title
    this.uuid = uuid
  }
}

class PpiConstraintsUrl {
  constructor(ppi = null, constraintsUrl = null, author = null, title = null, uuid = null) {
    this.ppi = ppi
    this.constraintsUrl = constraintsUrl
    this.author = author
    this.title = title
    this.uuid = uuid
  }
}

class Constraints {
  constructor(maxZoomLevelPercentage = null) {
    this.maxZoomLevelPercentage = maxZoomLevelPercentage
  }
}

const client = {
  getMetaDataForStories: function (metaEndpoint, containers, currentImage) {
    return new Promise(resolve => {
      Promise.all(containers).then(function (values) {
        const uuid = values[currentImage].data.canvasUuid
        let maxZoomPixelRatio = 1 // 100%
        client
          .getMetaData(metaEndpoint, uuid)
          .then(response => {
            maxZoomPixelRatio = response.maxZoomLevelPercentage / 100
            resolve(maxZoomPixelRatio)
          })
          .catch(err => {
            throw err
          })
      })
    })
  },

  /**
   * @param {string} metaEndpoint -> ex: /meta/images/search/findByUuid?uuid=
   * @param {string} uuid  -> univocal code of image cex: 0a18fc08-ff55-40d0-a86c-eeefa7cfcde3
   * @returns {*}
   */
  getMetaData: function (metaEndpoint, uuid) {
    return this.getPpiAndConstraintsUrl(metaEndpoint, uuid)
      .then(
        metadata => {
          if (metadata && metadata.constraintsUrl) {
            return this.getMaxZoomLevelPercentage(metadata.constraintsUrl)
              .then(
                constraints => {
                  if (
                    constraints &&
                    (constraints.maxZoomLevelPercentage || constraints.maxZoomLevelPercentage === null) &&
                    (metadata.ppi || metadata.ppi === null)
                  ) {
                    return new MetaData(
                      metadata.ppi,
                      constraints.maxZoomLevelPercentage,
                      metadata.author,
                      metadata.title,
                      metadata.uuid
                    )
                  } else {
                    new MetaData(null, null)
                  }
                },
                err => {
                  throw err
                }
              )
              .catch(err => {
                throw err
              })
          } else {
            return new Promise(resolve => {
              resolve(new MetaData(null, null))
            })
          }
        },
        err => {
          throw err
        }
      )
      .catch(err => {
        throw err
      })
  },
  getPpiAndConstraintsUrl: function (metaEndpoint, uuid) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', metaEndpoint + uuid, true)
      xhr.onload = () =>
        xhr.status === 200
          ? resolve(this.getMetadataFromResponse(xhr))
          : reject(Error(xhr.statusText + ' ' + xhr.status))
      xhr.onerror = e => reject(e)
      xhr.send(null)
    })
  },
  getMetadataFromResponse: function (xhr) {
    const json = JSON.parse(xhr.responseText)
    const response = json ? json : null
    let author = this.getAuthorFromResponse(response)
    let title = this.getTitleFromResponse(response)
    let uuid = this.getUuidFromResponse(response)
    let ppi = this.getPpiFromResponse(response)
    let urlConstraints = this.getConstraintsUrlFromResponse(response)
    return new PpiConstraintsUrl(ppi, urlConstraints, author, title, uuid)
  },
  getPpiFromResponse: function (response) {
    if (response && response.image) {
      return response.image.ppi
    } else {
      return null
    }
  },
  getAuthorFromResponse: function (response) {
    if (response) {
      return response.autn
    } else {
      return null
    }
  },
  getTitleFromResponse: function (response) {
    if (response) {
      return response.sgtt
    } else {
      return null
    }
  },
  getUuidFromResponse: function (response) {
    if (response) {
      return response.uuid
    } else {
      return null
    }
  },
  getConstraintsUrlFromResponse: function (response) {
    if (response && response._links && response._links.constraints) {
      return response._links.constraints.href
    } else {
      return null
    }
  },
  getMaxZoomLevelPercentage: function (constraintsUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', constraintsUrl, true)
      xhr.onload = () =>
        xhr.status === 200
          ? resolve(this.getConstraintsFromResponse(xhr))
          : reject(Error(xhr.statusText + ' ' + xhr.status))
      xhr.onerror = e => reject(e)
      xhr.send(null)
    })
  },
  getConstraintsFromResponse: function (xhr) {
    const json = JSON.parse(xhr.responseText)
    const response = json ? json : null
    let maxZoomLevelPercentage = this.getMaxZoomLevelPercentageFromResponse(response)
    return new Constraints(maxZoomLevelPercentage)
  },
  getMaxZoomLevelPercentageFromResponse: function (response) {
    if (response) {
      return response.maxZoomLevelPercentage
    } else {
      return null
    }
  }
}

export default client
